/**
 * This file registers an hook with the TransitionsService which protects a
 * route that requires authentication.
 *
 * Register a hook which redirects to /login when:
 * - The user is not authenticated
 * - The user is navigating to a state that requires authentication
 */
export const requiresAuth = ($state, $transitions) => {
  'ngInject';

  // Conditional role holder (set by requiresAuthCriteria hook)
  let requiredRole;

  // Matches if the destination state's data property has a truthy 'requiresAuth' property
  const requiresAuthCriteria = {
    to: (state) => {
      if (state.data) {
        const { requiresAuth } = state.data;
        if (requiresAuth) {
          // requiresAuth can be either a truthy value
          // or a string which defines the minimum user role.
          if (angular.isString(requiresAuth)) {
            requiredRole = requiresAuth;
          } else {
            // unset required role
            requiredRole = null;
          }
        }
        return requiresAuth;
      }
    }
  };

  // Function that returns a redirect for the current transition to the login state
  // if the user is not currently authenticated (according to the authService)
  const redirectToLogin = (trans) => {
    let authService = trans.injector().get('authService');
    if (!authService.isAuthenticated() || (requiredRole && !authService.grantRole(requiredRole))) {
      return $state.target('app.login', undefined, { location: true });
    }
  };

  // Register the "requires auth" hook with the TransitionsService
  $transitions.onBefore(requiresAuthCriteria, redirectToLogin, { priority: 10 });
}
